import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { AddFriends2 } from '@sorare/core/src/atoms/icons/AddFriends2';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Scrollable } from '@sorare/core/src/atoms/navigation/Scrollable';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { Card } from '@sorare/core/src/components/card/Card';

import { SlotsPreview_cardCollection } from './__generated__/index.graphql';

const Root = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 0 var(--double-unit);
`;
const EmptySlotWrapper = styled(Horizontal).attrs({ center: true })`
  height: 100%;
  border-radius: 6px;
  border: 1px solid var(--c-nl-200);
  background: var(--c-nl-200);
  backdrop-filter: blur(8px);
  aspect-ratio: var(--card-aspect-ratio);
`;

type Props = { cardCollection: SlotsPreview_cardCollection };
export const SlotsPreview = ({ cardCollection }: Props) => {
  const { slotsPreview } = cardCollection;

  return (
    <Root>
      <Scrollable
        itemToDisplay={2}
        overhang={6}
        scrollButtonsProps={{ hideButtonsOnMobile: true }}
        contained
        itemGap={1}
      >
        {slotsPreview.map(({ slug, highlightedCardCollectionCard, slot }) => {
          if (highlightedCardCollectionCard) {
            return (
              <Card key={slug} card={highlightedCardCollectionCard.anyCard} />
            );
          }
          return (
            <EmptySlotWrapper key={slug}>
              <Vertical gap={0.5} center>
                <AddFriends2 />
                <LabelS bold>{slot.player.lastName}</LabelS>
              </Vertical>
            </EmptySlotWrapper>
          );
        })}
      </Scrollable>
    </Root>
  );
};

SlotsPreview.fragments = {
  cardCollection: gql`
    fragment SlotsPreview_cardCollection on CardCollection {
      slug
      slotsPreview(forUserSlug: $user, first: 5) {
        slug
        slot {
          id
          player {
            slug
            lastName
          }
        }
        highlightedCardCollectionCard {
          id
          anyCard {
            slug
            ...Card_anyCard
          }
        }
      }
    }
    ${Card.fragments.anyCard}
  ` as TypedDocumentNode<SlotsPreview_cardCollection>,
};
